import LegalLayout from "@/components/LegalLayout";
import { COMPANY } from "@/lib/legalData";

const SUB_PROCESSORS = [
  {
    name: "Emergent Labs",
    service: "Infrastruttura cloud applicativa (hosting API + frontend)",
    location: "Unione Europea (Irlanda)",
    data: "Dati operativi applicativi (in transito e at rest)",
    guarantees: "DPA standard, ISO 27001, SCC dove applicabili",
    privacy_url: "https://emergent.sh/privacy",
  },
  {
    name: "MongoDB Atlas",
    service: "Database documentale (anagrafici, pratiche, configurazioni)",
    location: "Unione Europea (Francoforte, DE)",
    data: "Tutti i dati strutturati della piattaforma",
    guarantees: "DPA MongoDB, ISO 27001/27018, SOC 2",
    privacy_url: "https://www.mongodb.com/legal/privacy-policy",
  },
  {
    name: "Emergent Object Storage",
    service: "Storage media (foto, video, audio caricati dai clienti)",
    location: "Unione Europea",
    data: "File multimediali allegati alle pratiche",
    guarantees: "Encryption at rest, accessi controllati",
    privacy_url: "https://emergent.sh/privacy",
  },
  {
    name: "Resend (Inc.)",
    service: "Invio email transazionali (registrazioni, OTP, notifiche)",
    location: "USA — Standard Contractual Clauses (SCC) UE",
    data: "Email, nome destinatario, contenuto del messaggio",
    guarantees: "DPA Resend, SCC EU 2021/914",
    privacy_url: "https://resend.com/legal/privacy-policy",
  },
  {
    name: "Stripe Payments Europe Ltd.",
    service: "Pagamenti e abbonamenti (Fase 2 — in roadmap)",
    location: "Unione Europea (Irlanda)",
    data: "Dati fatturazione del consulente (no dati cliente finale)",
    guarantees: "DPA Stripe, PCI-DSS Level 1",
    privacy_url: "https://stripe.com/it/privacy",
  },
  {
    name: "PayPal (Europe) S.à.r.l.",
    service: "Pagamenti alternativi (Fase 2 — in roadmap)",
    location: "Unione Europea (Lussemburgo)",
    data: "Dati fatturazione del consulente",
    guarantees: "DPA PayPal, ISO 27001",
    privacy_url: "https://www.paypal.com/it/legalhub/privacy-full",
  },
  {
    name: "Twilio Ireland Ltd.",
    service: "Invio SMS firma cliente (in roadmap)",
    location: "Unione Europea (Irlanda)",
    data: "Numero telefono cliente, contenuto SMS",
    guarantees: "DPA Twilio, SCC EU",
    privacy_url: "https://www.twilio.com/it-it/legal/privacy",
  },
];

export default function SubProcessors() {
  return (
    <LegalLayout title="Sub-Responsabili del trattamento" slug="/sub-processors">
      <p className="lead">
        Ai sensi dell&apos;art. 28, par. 2 del Regolamento (UE) 2016/679 (GDPR), pubblichiamo l&apos;elenco completo
        dei sub-responsabili del trattamento utilizzati da <b>{COMPANY.legal_name}</b> per l&apos;erogazione
        del servizio <b>{COMPANY.brand}</b>.
      </p>

      <h2>Cos&apos;è un sub-responsabile</h2>
      <p>
        Un sub-responsabile (sub-processor) è un fornitore terzo che tratta dati personali per conto di {COMPANY.legal_name},
        nell&apos;ambito dell&apos;erogazione tecnica del servizio. Tutti i sub-responsabili operano sulla base di un
        Data Processing Agreement (DPA) firmato e, per i trasferimenti extra-UE, di Clausole Contrattuali Tipo (SCC)
        approvate dalla Commissione Europea con Decisione di esecuzione (UE) 2021/914.
      </p>

      <h2>Elenco aggiornato dei sub-responsabili</h2>

      <div className="overflow-x-auto -mx-4 sm:mx-0 my-6" data-testid="sub-processors-table">
        <table className="w-full min-w-[860px] border-collapse text-sm">
          <thead>
            <tr className="bg-slate-100 text-left">
              <th className="px-3 py-2 font-bold text-slate-700 text-xs uppercase tracking-wider">Fornitore</th>
              <th className="px-3 py-2 font-bold text-slate-700 text-xs uppercase tracking-wider">Servizio</th>
              <th className="px-3 py-2 font-bold text-slate-700 text-xs uppercase tracking-wider">Sede / Trasferimenti</th>
              <th className="px-3 py-2 font-bold text-slate-700 text-xs uppercase tracking-wider">Dati trattati</th>
              <th className="px-3 py-2 font-bold text-slate-700 text-xs uppercase tracking-wider">Garanzie</th>
              <th className="px-3 py-2 font-bold text-slate-700 text-xs uppercase tracking-wider">Privacy fornitore</th>
            </tr>
          </thead>
          <tbody>
            {SUB_PROCESSORS.map((sp) => (
              <tr key={sp.name} className="border-b border-slate-200 align-top" data-testid={`subproc-${sp.name.replace(/\s/g, "-").toLowerCase()}`}>
                <td className="px-3 py-3 font-bold text-[#1E293B]">{sp.name}</td>
                <td className="px-3 py-3 text-slate-700">{sp.service}</td>
                <td className="px-3 py-3 text-slate-700">{sp.location}</td>
                <td className="px-3 py-3 text-slate-700">{sp.data}</td>
                <td className="px-3 py-3 text-slate-700">{sp.guarantees}</td>
                <td className="px-3 py-3">
                  <a href={sp.privacy_url} target="_blank" rel="noopener noreferrer" className="text-[#2456C6] hover:underline font-bold text-xs">
                    Vedi →
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h2>Aggiornamenti dell&apos;elenco</h2>
      <p>
        L&apos;elenco è aggiornato ogni volta che {COMPANY.legal_name} introduce, sostituisce o rimuove un sub-responsabile.
        In caso di introduzione di un nuovo sub-responsabile, i Clienti professionali ricevono comunicazione
        via email con almeno <b>30 giorni di anticipo</b>, con possibilità di obiezione motivata ai sensi dell&apos;art. 28.2 GDPR.
      </p>

      <h2>Contatti privacy</h2>
      <p>
        Per qualsiasi domanda relativa al trattamento dei dati o ai sub-responsabili, è possibile scrivere a:
      </p>
      <ul>
        <li><b>Email Privacy:</b> <a href={`mailto:${COMPANY.privacy_email}`}>{COMPANY.privacy_email}</a></li>
        <li><b>PEC:</b> <a href={`mailto:${COMPANY.pec}`}>{COMPANY.pec}</a></li>
      </ul>
    </LegalLayout>
  );
}
